import React from 'react';
import PropTypes from 'prop-types';
import { IntlProvider } from 'react-intl';
import merge from 'lodash/merge';

import flattenMessages from './flattenMessages';

import error404 from './404';
import global from './global';
import home from './home';
import decrypt from './decrypt';
import payment from './payment';
import avalanche from './avalanche';
import bnb from './bnb';
import bitcoin from './bitcoin';
import bitcoinCash from './bitcoin-cash';
import ethereum from './ethereum';
import tether from './tether';
import compound from './compound';
import polygon from './polygon';
import usdCoin from './usd-coin';
import uniSwap from './uni-swap';
import sushiSwap from './sushi-swap';
import verse from './verse';
import wrappedBtc from './wrapped-btc';
import yearnFinance from './yearn-finance';
import zano from './zano';

import { DEFAULT_LOCALE, appLocales } from '.';

const messagesMap = {
  404: error404,
  global,
  home,
  decrypt,
  payment,
  avalanche,
  bitcoin,
  'bitcoin-cash': bitcoinCash,
  bnb,
  ethereum,
  polygon,
  tether,
  compound,
  'usd-coin': usdCoin,
  'uni-swap': uniSwap,
  'sushi-swap': sushiSwap,
  verse,
  'wrapped-btc': wrappedBtc,
  'yearn-finance': yearnFinance,
  zano,
  wc: home,
};

const Intl = props => {
  const { localeDir, children, locale, netlify } = props;
  // console.log(localeDir, locale);
  const splitLocaleDir = localeDir
    .split('/')
    .reduce((prev, curr) => (curr === '' ? prev : [...prev, curr]), []);

  // console.log(splitLocaleDir);
  let pageName = '404';

  Object.keys(messagesMap).forEach(value => {
    if (splitLocaleDir.includes(value)) pageName = value;
  });

  pageName = splitLocaleDir[splitLocaleDir.length - 1];

  if (splitLocaleDir.length === 0) pageName = 'home';
  if (
    splitLocaleDir.length === 1 &&
    Object.keys(appLocales).includes(splitLocaleDir[0])
  )
    pageName = 'home';
  /* locale === DEFAULT_LOCALE && splitLocaleDir.length === 0
      ? 'home'
      : splitLocaleDir[0]; */

  // console.log('hoc pageName:', pageName);
  const locales = messagesMap[pageName] || messagesMap['404'];
  // console.log('hoc locales:', locales[locale]);

  Object.keys(locales).forEach(lang => {
    locales[lang] = { ...locales[lang], ...messagesMap['404'][lang] };
  });

  const globalMessages =
    messagesMap.global[locale] || messagesMap.global[DEFAULT_LOCALE] || {};

  const homeDefaultMessages = home[DEFAULT_LOCALE] || {};
  const homeMessages = home[locale] || home[DEFAULT_LOCALE] || {};

  const defaultLocaleMessages = locales[DEFAULT_LOCALE] || {};
  const currentLocaleMessages = locales[locale] || defaultLocaleMessages;

  const messages = netlify
    ? merge(
        {},
        messagesMap.global[DEFAULT_LOCALE],
        homeDefaultMessages,
        homeMessages,
        defaultLocaleMessages,
        flattenMessages(netlify, pageName),
      )
    : merge(
        {},
        globalMessages,
        homeDefaultMessages,
        homeMessages,
        defaultLocaleMessages,
        currentLocaleMessages,
      );

  return (
    <IntlProvider
      locale={locale}
      defaultLocale={DEFAULT_LOCALE}
      messages={messages}
    >
      {children}
    </IntlProvider>
  );
};

Intl.propTypes = {
  locale: PropTypes.string.isRequired,
  localeDir: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  netlify: PropTypes.shape({}),
};

Intl.defaultProps = {
  netlify: undefined,
};

export default Intl;
